/* eslint-disable no-console */
// eslint-disable-next-line flowtype/require-valid-file-annotation
import { JL } from 'jsnlog';
import browserInfo from 'browser-info';
import Logger from 'modules/Logger';
import getAppConfig from 'constants/getAppConfig';
import configureJsnlog from './configureJsnlog';
import getSessionId from './getSessionId';
import toJson from './toJson';

const {
  urls: { bff: bffUrl },
  isDev,
  version,
} = getAppConfig();
const { errorLogAppender, telemetryLogAppender } = configureJsnlog(JL, bffUrl);
const sessionId = getSessionId();

/**
 * Call before redirecting, causes all logs to be sent to the logging server
 *
 * @return {Void} nothing
 */
export const flushLogs = () => {
  errorLogAppender.sendBatch();
  telemetryLogAppender.sendBatch();
};

const appendAdditonalData = (logObj: any, data: any) => {
  const safeData = toJson(data);
  // eslint-disable-next-line no-param-reassign
  logObj.additionalData = safeData;

  return logObj;
};

const appendAdditionalProperties = (logObj: any, data: any) => ({
  ...logObj,
  ...data,
});

const createServerLogger = (dataAppender: any) =>
  /**
   * Example logger, that just logs to the console, will need to be hooked up to
   * the server logging
   *
   * @param {String} level The log level
   * @param {String} message The log message
   * @param {Any} [data] Any data passed with the log
   * @param {Boolean} [fromConsoleWrap] Whether the log came from a console statement
   * @return {Void} No return value
   */
  (level: string, message: string, data: any, fromConsoleWrap: boolean) => {
    let sourceContext = 'Component';

    /* istanbul ignore next */
    if (fromConsoleWrap) {
      sourceContext = 'console';
    }

    let logObj = {
      url: window.location.href,
      message,
      sourceContext,
      component: 'web',
      version,
      device: {
        agent: navigator.userAgent,
        ...browserInfo(),
        screenResolution: `${window.screen.width}x${window.screen.height}`,
      },
      sessionId,
    };

    try {
      logObj = dataAppender(logObj, data);
    } catch (e) {
      /* istanbul ignore next */
      if (!fromConsoleWrap) {
        console.error('Could not convert log data to a json object', e);
      }
    }

    try {
      // @ts-ignore
      JL()[level](logObj);
    } catch (e) {
      /* istanbul ignore next */
      if (!fromConsoleWrap) {
        console.error('Could not send the log to the server, something is very wrong', e);
      }
    }

    /* istanbul ignore next */
    if (fromConsoleWrap) {
      return;
    }

    /* istanbul ignore next */
    if (isDev) {
      console.log({
        level,
        message,
        data,
      });
    }
  };

const logLevels = {
  debug: 'debug',
  log: 'log',
  info: 'info',
  warn: 'warn',
  error: 'error',
  fatal: 'fatal',
};

export const AdditionalPropertyLogger = new Logger(
  createServerLogger(appendAdditionalProperties),
  logLevels,
  false
).getLogger();

export default new Logger(createServerLogger(appendAdditonalData), logLevels, true).getLogger();
